import React, { Component, Fragment }  from 'react';
import { connect }           from 'react-redux';

import * as popups from '../../constants/popup-types';

//Import components
import MainMenu from './MainMenu';
import Burger   from '../../components/common/buttons/burger/burger';
import * as routes from '../../constants/routes';
//Import actions
import { setBurgerState , addPopup } from '../../redux/actions';


//Assets
import './header.scss';
import Logo from 'assets/icons/logo.svg';
import like_icon from 'assets/icons/heart_icon_black.svg';
import pointIcon from 'assets/icons/point_icon.svg';
import lovedBlue from 'assets/icons/loved_icon_blue.svg';
import hz from 'assets/icons/hz.svg';

class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            location:'',
            show_hover: false,
        };

        this.handleBurgerClick = this.handleBurgerClick.bind(this);
        this.handleFavoritesClick = this.handleFavoritesClick.bind(this);
        this.handleLogoClick = this.handleLogoClick.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);

        this.interval = false;
    }


    componentDidMount(){
        const res = this.props.history.location.pathname.split('/');
        if (res[1] === 'order')
            this.setState({location:'order'});
    }

    handleBurgerClick() {
        const new_state = !this.props.burgerMenuState;
        this.props.setBurgerState(new_state);
    }

    handleFavoritesClick(){
        this.props.addPopup({type:popups.FAVORITES});
    }

    handleLogoClick(){
        this.props.history.push(routes.home);
    }

    onMouseOver(){
        document.getElementById('love_icon').src = lovedBlue;

        if (Object.keys(this.props.favorites).length < 1) {
            this.setState({show_hover: true});
        }
    }

    onMouseOut(){
        document.getElementById('love_icon').src = like_icon;
        this.setState({show_hover: false});
    }

    render() {
        const text = this.props.text;

        const isMobile = this.props.deviceState === 'mobile';
        const isTablet = this.props.deviceState === 'tablet';
        const isLaptop = this.props.deviceState === 'desktop';
        const isDesktop = this.props.deviceState === 'desktop_large';


        if (Object.keys(this.props.favorites).length > 0) {
            if (!this.interval) {
                let icon = document.getElementById('love_icon');
                if (icon !== null) {
                    this.interval = setInterval(() => {
                        if (icon.src.includes(lovedBlue)) {
                            icon.src = like_icon;
                        } else {
                            icon.src = lovedBlue;
                        }
                    }, 1000);
                }
            }
        } else {
            if (this.interval){
                let icon = document.getElementById('love_icon');
                clearInterval(this.interval);
                this.interval = false;
                icon.src = like_icon;
            }
        }


        return (

            <header>
                { (isMobile || isTablet) && <Burger onClick = { this.handleBurgerClick } /> }
                { (isLaptop || isDesktop) &&
                    <Fragment>
                    <div className="user_area">
                        <div className="item"
                             onMouseOver={this.onMouseOver}
                             onMouseOut={this.onMouseOut}
                             onClick={()=> this.handleFavoritesClick()}>
                            <img id='love_icon' className="icon" src= {like_icon} alt="איזור אישי"/>
                            <div className="text">{text['header_loved']}</div>
                            {this.state.show_hover && <div className='fave-msg'>{text['header_fav_msg']}</div>}
                        </div>
                    </div>
                    <div className="divider"/>
                    </Fragment>
                }
                <div className="info">
                    <div className="icon">
                        <img className='pointIcon' src={pointIcon} alt='\'/>
                    </div>
                    <div className="text">{text['header_text']}</div>
                </div>
                { (isLaptop || isDesktop) && <MainMenu />}
                <div className="logo_wrapper">
                    <img className="logo" src={Logo} alt="logo" onClick={this.handleLogoClick}/>
                </div>
            </header>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        burgerMenuState: store.state.burgerMenuState,
        favorites: store.data.Favorites,
        text: store.config.Translations,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setBurgerState: (device) => dispatch(setBurgerState(device)),
        addPopup: (payload) => dispatch(addPopup(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Header);
